import { cn } from "@/lib/utils";

type DashboardPageProps = {
  children: React.ReactNode;
  className?: string;
};

export default function DashboardPage({ children, className }: DashboardPageProps) {
  return <div className={cn("dashboard-page", className)}>{children}</div>;
}
